import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import { useMediaPreloader } from "@/hooks/useMediaPreloader";
import HomePage from "./pages/Home";
import OurTeam from "./pages/OurTeam";
import AutoDock from "./pages/AutoDock";
import AMRs from "./pages/AMRs";
import Samplerun from "./pages/Samplerun";
import NotFound from "./pages/NotFound";
import GalleryVariantsDemo from "./components/GalleryVariantsDemo";
import AnalyticsListener from "@/hooks/AnalyticsListener";
import SolutionsSidebar from "@/components/SolutionsSidebar";  // Import the sidebar

const App = () => {
  useMediaPreloader();

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 5 * 60 * 1000, retry: 1 },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AnalyticsListener />
          <SolutionsSidebar /> {/* Sidebar added here */}
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/autodock" element={<AutoDock />} />
            <Route path="/amrs" element={<AMRs />} />
            <Route path="/Samplerun" element={<Samplerun />} />
            <Route path="/gallery-variants" element={<GalleryVariantsDemo />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
